import React from 'react'
import FormWrapper from '../../../layout/formLayout/FormWrapper'
import Header from '../../../components/form/Header'
import LoginForm from '../../../components/auth/Login'

export default function AdminLogin() {
    return (
        <>
            <FormWrapper>
                <div>
                    <Header title="Admin Login" />
                    <LoginForm category="admin" redirect="/admin" />
                </div>
            </FormWrapper>
        </>
    )
}
